/** Code-native illustrations matching the supplied lifecycle artwork. */
export function LifecycleIllustration({step}:{step:number}) {
  return <svg className={`lifecycle-icon step-icon-${step}`} viewBox="0 0 120 88" fill="none" aria-hidden="true">
    {step===0&&<g stroke="currentColor" strokeWidth="3" strokeLinejoin="round">
      <circle cx="53" cy="40" r="30"/>
      <circle cx="53" cy="30" r="10" fill="currentColor" stroke="none"/>
      <path d="M37 62V52c0-15 32-15 32 0v10" fill="currentColor" stroke="none"/>
      <circle cx="83" cy="65" r="16" fill="var(--bg-deep)"/>
      <path d="M74 65h18m-9-9v18" strokeWidth="2"/>
    </g>}
    {step===1&&<g fill="currentColor">
      <path d="M20 69h9v10h-9zm14-5h9v15h-9zm14-8h9v23h-9zm14-9h9v32h-9zm14-14h9v46h-9zm14-17h9v63h-9z"/>
      <path d="M18 63C45 61 72 39 95 10" stroke="currentColor" strokeWidth="3.5"/>
      <path d="m86 10 16-6-2 17z"/>
    </g>}
    {step===2&&<g>
      <defs><linearGradient id="lifecycle-solana" x1="91" y1="13" x2="28" y2="77" gradientUnits="userSpaceOnUse"><stop stopColor="#72F7D7"/><stop offset=".5" stopColor="#4B9BAE"/><stop offset="1" stopColor="#A77AFF"/></linearGradient></defs>
      <path d="m35 19-13 13h62l13-13zm-13 25 13 13h62L84 44zm13 25-13 13h62l13-13z" transform="translate(0 -6)" fill="url(#lifecycle-solana)"/>
    </g>}
    {step===3&&<g stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round">
      <rect x="9" y="12" width="48" height="64" rx="5"/><rect x="15" y="18" width="35" height="51" rx="2"/>
      <path d="M9 25H5v12h4m0 13H5v12h4m7 14v5m33-5v5"/>
      <circle cx="33" cy="43" r="11"/><circle cx="33" cy="43" r="5"/>
      <path d="m26 35 4 4m7 8 4 4m-15 0 4-4m7-8 4-4"/>
      <path d="M67 19h35v61l-6-4-6 4-6-4-6 4-6-4-5 4zM74 27h21m-21 6h21m-21 6h21m-21 27h21"/>
      <path d="M77 60V46h9q7 0 7 5t-7 5h-9m9 0 8 8"/>
    </g>}
    {step===4&&<g stroke="currentColor" strokeWidth="2.8">
      <circle cx="31" cy="43" r="27"/><circle cx="31" cy="33" r="9" fill="currentColor" stroke="none"/>
      <path d="M16 61v-8c0-15 30-15 30 0v8" fill="currentColor" stroke="none"/>
      <path d="M64 31h18m-6-6 6 6-6 6m6 17H64m6-6-6 6 6 6" strokeWidth="2"/>
      <ellipse cx="102" cy="43" rx="15" ry="27"/>
      <path d="M96 57V29h7q10 0 10 8t-10 8h-7m7 0 10 13M100 25v4m0 28v5"/>
    </g>}
  </svg>;
}
